export const SORT_DIRECTIONS = {
	ASC: 'asc',
	DESC: 'desc'
};

export const SORT_COLUMNS = {
	TITLE: { name: 'Title', key: 'title' },
	INSTRUCTOR: { name: 'Instructor', key: 'instructor' },
	LIKES: { name: 'Likes', key: 'likes' },
	DISLIKES: { name: 'Dislikes', key: 'dislikes' },
	VIDEO_ADDED: { name: 'Video Added', key: 'videoAdded' },
	DATE_ADDED: { name: 'Reaction Date', key: 'dateAdded' }
};

export const SORTABLE_COLUMNS = Object.values(SORT_COLUMNS).map(column => column.key);

export const DEFAULT_SORT_BEHAVIOUR = {
	[SORT_COLUMNS.TITLE.key]: SORT_DIRECTIONS.ASC,
	[SORT_COLUMNS.INSTRUCTOR.key]: SORT_DIRECTIONS.ASC,
	[SORT_COLUMNS.LIKES.key]: SORT_DIRECTIONS.DESC,
	[SORT_COLUMNS.DISLIKES.key]: SORT_DIRECTIONS.DESC,
	[SORT_COLUMNS.VIDEO_ADDED.key]: SORT_DIRECTIONS.DESC,
	[SORT_COLUMNS.DATE_ADDED.key]: SORT_DIRECTIONS.DESC
};

export const SORT_MAPPINGS = {
	[SORT_COLUMNS.TITLE.key]: {
		[SORT_DIRECTIONS.ASC]: 'title_asc',
		[SORT_DIRECTIONS.DESC]: 'title_desc'
	},
	[SORT_COLUMNS.INSTRUCTOR.key]: {
		[SORT_DIRECTIONS.ASC]: 'instructor_asc',
		[SORT_DIRECTIONS.DESC]: 'instructor_desc'
	},
	[SORT_COLUMNS.LIKES.key]: {
		[SORT_DIRECTIONS.ASC]: 'likes_asc',
		[SORT_DIRECTIONS.DESC]: 'likes_desc'
	},
	[SORT_COLUMNS.DISLIKES.key]: {
		[SORT_DIRECTIONS.ASC]: 'dislikes_asc',
		[SORT_DIRECTIONS.DESC]: 'dislikes_desc'
	},
	[SORT_COLUMNS.VIDEO_ADDED.key]: {
		[SORT_DIRECTIONS.ASC]: 'video_oldest',
		[SORT_DIRECTIONS.DESC]: 'video_newest'
	},
	[SORT_COLUMNS.DATE_ADDED.key]: {
		[SORT_DIRECTIONS.ASC]: 'oldest',
		[SORT_DIRECTIONS.DESC]: 'newest'
	}
};
